import { SupplierRelationshipListResponseType } from "@sellar-io/api-v2/types";
import {
  RadioSelector,
  RadioSelectorItem,
  InputNumber,
} from "@sellar-io/components";
import { InputLabel, InputField } from "@sellar-io/components";

export const EditCreditTermsFormFragment = ({
  setPaymentDueCalculateFrom,
  paymentDueCalculateFrom,
  paymentDue,
  setPaymentDue,
  required,
  reasonForRequest,
  setReasonForRequest,
}: {
  setPaymentDueCalculateFrom: (
    value: SupplierRelationshipListResponseType[number]["paymentDueCalculateFrom"],
  ) => void;
  paymentDueCalculateFrom:
    | SupplierRelationshipListResponseType[number]["paymentDueCalculateFrom"]
    | null
    | undefined;
  paymentDue: number | null | undefined;
  setPaymentDue: (paymentDue: number) => void;
  required: boolean;
  reasonForRequest?: string | null | undefined;
  setReasonForRequest?: (reasonForRequest: string | null | undefined) => void;
}) => {
  const reasonOne = "I haven't been set up correctly with my usual terms";
  const reasonTwo = "I want to request better terms with this supplier";
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <InputLabel>Payment due - calculate from</InputLabel>
        <RadioSelector
          onChange={(e) =>
            setPaymentDueCalculateFrom(
              e.currentTarget
                .value as SupplierRelationshipListResponseType[number]["paymentDueCalculateFrom"],
            )
          }
          value={paymentDueCalculateFrom ?? ""}
          required={true}
          variant="grouped"
        >
          <RadioSelectorItem
            value={"invoiceIssueDate"}
            title={"Invoice issue date"}
            description={""}
          />
          <RadioSelectorItem
            value={"endOfMonth"}
            title={"End of month"}
            description={""}
          />
          <RadioSelectorItem
            value={"endOfFollowingMonth"}
            title={"End of following month"}
            description={""}
          />
        </RadioSelector>
      </div>

      <InputField className="gap-2" label="Number of days credit">
        <InputNumber
          placeholder={"30"}
          value={paymentDue ?? undefined}
          required={required}
          min={0}
          onChange={(e) => setPaymentDue(parseInt(e.target.value))}
        />
      </InputField>
      {setReasonForRequest && (
        <div className="flex flex-col gap-2">
          <InputLabel>Reason for request</InputLabel>
          <RadioSelector
            onChange={(e) => setReasonForRequest(e.currentTarget.value)}
            value={reasonForRequest ?? ""}
            required={true}
            variant="grouped"
          >
            <RadioSelectorItem
              value={reasonOne}
              title={reasonOne}
              description={""}
            />
            <RadioSelectorItem
              value={reasonTwo}
              title={reasonTwo}
              description={""}
            />
          </RadioSelector>
        </div>
      )}
    </div>
  );
};
